import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withKeys as _withKeys, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue";
import _imports_0 from '../image/search.png';
import _imports_1 from '../image/join_s_arrow.png';
import _imports_2 from '../image/pli_arrow.png';
var _hoisted_1 = {
  class: "join_us_box"
};
var _hoisted_2 = {
  class: "join_box container"
};

var _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "join_us_title"
}, "Join Us", -1);

var _hoisted_4 = {
  class: "join_serach_box"
};
var _hoisted_5 = {
  class: "join_s_big_box"
};
var _hoisted_6 = {
  class: "join_s_b"
};
var _hoisted_7 = {
  class: "join_select_box"
};

var _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "join_s_arrow"
}, null, -1);

var _hoisted_9 = {
  class: "join_select_box_two"
};

var _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "join_s_arrow"
}, null, -1);

var _hoisted_11 = {
  key: 0,
  class: "noMore"
};
var _hoisted_12 = ["onClick"];
var _hoisted_13 = {
  class: "pli_text"
};
var _hoisted_14 = {
  class: "jobTitle"
};
var _hoisted_15 = {
  class: "workPlace"
};

var _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  class: "pli_arrow"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "pli_arrow"
})], -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_option = _resolveComponent("el-option");

  var _component_el_select = _resolveComponent("el-select");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
    class: "join_serach",
    onKeyup: _cache[2] || (_cache[2] = _withKeys(function ($event) {
      return _ctx.getJobsList();
    }, ["enter"]))
  }, [_withDirectives(_createElementVNode("input", {
    type: "text",
    class: "join_s_input",
    placeholder: "Search",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.searchValue = $event;
    })
  }, null, 512), [[_vModelText, _ctx.searchValue]]), _createElementVNode("img", {
    src: _imports_0,
    class: "join_s_icon",
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.getJobsList();
    })
  })], 32)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
    class: "join_s_selet",
    onClick: _cache[3] || (_cache[3] = function () {
      return _ctx.upJoinClk && _ctx.upJoinClk.apply(_ctx, arguments);
    })
  }, [_createTextVNode(_toDisplayString(_ctx.location) + " ", 1), _hoisted_8]), _createVNode(_component_el_select, {
    ref: "select",
    modelValue: _ctx.location,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
      return _ctx.location = $event;
    }),
    placeholder: "Select",
    size: "large",
    style: {
      "width": "160px"
    },
    class: "el_select"
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locationList, function (item) {
        return _openBlock(), _createBlock(_component_el_option, {
          key: item.dictLabel,
          value: item.dictLabel
        }, null, 8, ["value"]);
      }), 128))];
    }),
    _: 1
  }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
    class: "join_s_selet_two",
    onClick: _cache[5] || (_cache[5] = function () {
      return _ctx.upJoinClkTwo && _ctx.upJoinClkTwo.apply(_ctx, arguments);
    })
  }, [_createTextVNode(_toDisplayString(_ctx.department) + " ", 1), _hoisted_10]), _createVNode(_component_el_select, {
    ref: "selectTwo",
    modelValue: _ctx.department,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
      return _ctx.department = $event;
    }),
    placeholder: "Select",
    size: "large",
    style: {
      "width": "160px"
    },
    class: "el_select"
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.departmentList, function (item) {
        return _openBlock(), _createBlock(_component_el_option, {
          key: item.dictLabel,
          value: item.dictLabel
        }, null, 8, ["value"]);
      }), 128))];
    }),
    _: 1
  }, 8, ["modelValue"])])])]), _ctx.jboList.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_11, " No more ")) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jboList, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      class: "position_list_item",
      key: index,
      onClick: function onClick($event) {
        return _ctx.jobSelect(item);
      }
    }, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, _toDisplayString(item.jobTitle), 1), _createElementVNode("div", _hoisted_15, "Workplace：" + _toDisplayString(item.workPlace), 1)]), _hoisted_16], 8, _hoisted_12);
  }), 128))])]);
}